import React from 'react';
import './SuggestionsBar.css';

const SuggestionsBar = ({ suggestions, onSuggestionClick }) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  // Map suggestions to icons
  const getIcon = (suggestion) => {
    const lowerSuggestion = suggestion.toLowerCase();
    
    if (lowerSuggestion.includes('price') || lowerSuggestion.includes('pricing') || lowerSuggestion.includes('cost')) {
      return '💰';
    } else if (lowerSuggestion.includes('schedule') || lowerSuggestion.includes('date')) {
      return '📅';
    } else if (lowerSuggestion.includes('course') || lowerSuggestion.includes('training')) {
      return '📚';
    } else if (lowerSuggestion.includes('certification') || lowerSuggestion.includes('certified')) {
      return '🎓';
    } else if (lowerSuggestion.includes('contact') || lowerSuggestion.includes('sales') || lowerSuggestion.includes('advisor')) {
      return '📞';
    } else if (lowerSuggestion.includes('aws')) {
      return '☁️';
    } else if (lowerSuggestion.includes('azure')) {
      return '🔷';
    } else if (lowerSuggestion.includes('devops')) {
      return '⚙️';
    } else if (lowerSuggestion.includes('quote')) {
      return '💵';
    } else if (lowerSuggestion.includes('group')) {
      return '👥';
    } else if (lowerSuggestion.includes('notification')) {
      return '🔔';
    } else if (lowerSuggestion.includes('support')) {
      return '🎧';
    } else {
      return '💡';
    }
  };

  return (
    <div className="suggestions-bar">
      <div className="suggestions-container">
        {suggestions.map((suggestion, idx) => (
          <button 
            key={idx}
            className="suggestion-chip"
            onClick={() => onSuggestionClick(suggestion)}
          >
            <span className="chip-icon">{getIcon(suggestion)}</span>
            <span className="chip-text">{suggestion}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestionsBar;

